<template>
  <TeaserAccountTile>
    <template v-slot:component>
      <Card :title="$t('userExistsPage.title')" :footerDivider="false">
        <template v-slot:content>
          <div>{{ $t('userExistsPage.info') }}</div>
          <span v-if="!isDa()" class="additionalInfo">
            <br />
            <div v-dompurify-html="$t('userExistsPage.info-additional')"></div>
          </span>
        </template>
        <template v-slot:footer>
          <div class="footer-cta footer-cta--left">
            <CustomButton
              @click="onSubmit"
              id="login-button"
              :buttonColor="ButtonColor.PRIMARY"
              :pendingState="pending"
              >{{ $t('userExistsPage.login-button') }}
            </CustomButton>
          </div>
        </template>
      </Card>
    </template>
  </TeaserAccountTile>
</template>

<script setup lang="ts">
import { navigate } from '@/utils/NavigationUtils'
import { ButtonColor, Card, CustomButton } from 'de-zurich-ui-library'
import TeaserAccountTile from '@/components/rahmen/TeaserAccountTile.vue'
import { ref } from 'vue'
import { isDa } from '@/utils/CommonUtils.ts'

const pending = ref(false)

function onSubmit(): void {
  pending.value = true
  navigate(globalThis.ENV_CONFIG?.REDIRECTS.LOGIN_PAGE)
}
</script>
<style lang="scss" scoped>
.card .card__content {
  padding-bottom: 0 !important;
}
</style>
